export default __webpack_public_path__ + "static/media/IMG_3.67455a1b.png";